import type {PartValueModifier} from 'schemaDefinition/types';
import {winnerValueModifier} from './winnerValueModifier';

export const interceptPrizeSetFieldValue: PartValueModifier = parameters => {
  const {value, valuePath} = parameters;

  if (valuePath.startsWith('winners[')) {
    return winnerValueModifier(parameters);
  }

  return {value};
};
